import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnChanges, Optional, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ConstructionSiteImportModel } from 'src/app/models/imports/construction-site-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-construction-site',
  templateUrl: './import-construction-site.component.html',
  styleUrls: ['./import-construction-site.component.scss'],
  standalone: false
})
export class ImportConstructionSiteComponent implements OnChanges {

  constructionSiteImport: boolean = false;
  constructionSiteAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  errorConstructionSite: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;

  constructor(private constructionSiteService: ConstructionSiteService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  ngOnChanges(changes: SimpleChanges) {
    const openImportConstructionSiteModal = changes["openImportConstructionSiteModal"];
    if (!openImportConstructionSiteModal) {
      return;
    }
    if (openImportConstructionSiteModal.firstChange) {
      return;
    }
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('importConstructionSiteButton')?.click();
    }
  }

  attach() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.constructionSiteImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadErrorsTxt() {
    if (!this.constructionSiteAlerts || this.constructionSiteAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar.'
      );
      return;
    }

    this.constructionSiteService.exportImportErrors(this.constructionSiteAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionObras_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.constructionSiteService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaObras.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async importConstructionSites() {
    this.constructionSiteAlerts = [];
    this.errorConstructionSite = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<ConstructionSiteImportModel>();
    let row: ConstructionSiteImportModel;
    let counter: number = 1, branchCode: number, code: number, alterCode: string | null, name: string, enterpriseCode: number, conceptCode: number,
      swInvoiceMonthly: boolean, zoneCode: number, address: string | null, phone: string | null, alterPhone: string | null,
      email: string | null, clientDocument: string, clientDocument2: string | null, invoiceAddress: string | null,
      invoicePhone: string | null, invoiceAlterPhone: string | null, invoiceEmail: string | null, observation: string | null,
      swIcaRetainer: boolean, sellerDocument: string, originDepartmentCode: string, originCityCode: string, destinityDepartmentCode: string,
      destinityCityCode: string, constructionSiteStateId: number;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {

      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          `El archivo ingresado no tiene registros para importar.`
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de la sucursal no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //B. Código Obra:
        code = parseFloat(element[1] as string);
        if (isNaN(code)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código de la obra no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //C. Código Alterno:
        alterCode = element[2] as string;
        if (alterCode != null) {
          if (alterCode.length > 10) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. El código alterno supera el tamaño máximo de caracteres (10)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //D. Nombre Obra:
        name = element[3] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El nombre Obra no es válido`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El Nombre supera el tamaño máximo de caracteres (70)`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //E. Código Empresa:
        enterpriseCode = parseFloat(element[4] as string);
        if (isNaN(enterpriseCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El código de la empresa no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //F. Tipo Negocio:
        conceptCode = element[5] as string != null ? parseFloat(element[5] as string) : 0;
        if (isNaN(conceptCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código del tipo de negocio no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //G. Período de Facturación:
        if (element[6] as string != "M" && element[6] as string != "Q") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El período debe ser valores como: M / Q.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }
        swInvoiceMonthly = element[6] as string === "M" ? true : false;

        //H. Código Zona:
        zoneCode = parseFloat(element[7] as string);
        if (isNaN(zoneCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El código de la zona no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //I. Dirección Obra:
        address = element[8] as string;
        if (address != null) {
          if (address.length > 70) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. La dirección obra supera el tamaño máximo de caracteres (70)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //J. Teléfono:
        phone = element[9] as string;
        if (phone != null) {
          if (phone.length < 7 || phone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna J. El teléfono obra del cliente no tiene una longitud válida. (7-15)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //K. Teléfono alterno
        alterPhone = element[10] as string;
        if (alterPhone != null) {
          if (alterPhone.length < 7 || alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna K. El teléfono obra alterno del cliente no tiene una longitud válida. (7-15)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //L. E-mail:
        email = element[11] as string;
        if (email != null) {
          if (email.length > 250) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna L. El E-mail obra del cliente no tiene una longitud válida. (250)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //M. Documento Cliente:
        clientDocument = element[12] as string;
        if (clientDocument == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. El documento del cliente no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        } else if (clientDocument.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. El documento del cliente supera el tamaño máximo de caracteres (15)`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //N. Documento2 Cliente:
        clientDocument2 = element[13] as string;
        if (clientDocument2 != null) {
          if (clientDocument2.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna N. El documento 2 del cliente supera el tamaño máximo de caracteres (15)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //O. Dirección Factura:
        invoiceAddress = element[14] as string;
        if (invoiceAddress != null) {
          if (invoiceAddress.length > 70) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna O. La dirección de factura supera el tamaño máximo de caracteres (70)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //P. Teléfono 1 Factura:
        invoicePhone = element[15] as string;
        if (invoicePhone != null) {
          if (invoicePhone.length < 7 || invoicePhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna P. El teléfono de factura no tiene una longitud válida. (7-15)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //Q. Teléfono 2 Factura:
        invoiceAlterPhone = element[16] as string;
        if (invoiceAlterPhone != null) {
          if (invoiceAlterPhone.length < 7 || invoiceAlterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna Q. El teléfono 2 de factura no tiene una longitud válida. (7-15)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //R. E-mail Factura:
        invoiceEmail = element[17] as string;
        if (invoiceEmail != null) {
          if (invoiceEmail.length > 250) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna R. El e-mail de factura supera el tamaño máximo de caracteres (250)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //S. Observación:
        observation = element[18] as string;
        if (observation != null) {
          if (observation.length > 250) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna S. La observación supera el tamaño máximo de caracteres (250)`;
            this.constructionSiteAlerts.push(alert);
            rowHasError = true;
          }
        }

        //T. Retenedor ICA:
        if (element[19] as string != "S" && element[19] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna T. El campo retenedor de ICA debe ser valores como: S / N.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }
        swIcaRetainer = element[19] as string === "S" ? true : false;

        //U. Documento Vendedor:
        sellerDocument = element[20] as string;
        if (sellerDocument == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna U. El documento del vendedor no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        } else if (sellerDocument.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna U. El documento del vendedor supera el tamaño máximo de caracteres (15)`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //V. Código Departamento Origen:
        originDepartmentCode = element[21] as string;
        if (originDepartmentCode == null || originDepartmentCode.length > 2) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna V. El código del departamento origen no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //W. Código Ciudad Origen:
        originCityCode = element[22] as string;
        if (originCityCode == null || originCityCode.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna W El código de la ciudad origen no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //X. Código Departamento Destino:
        destinityDepartmentCode = element[23] as string;
        if (destinityDepartmentCode == null || destinityDepartmentCode.length > 2) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna X. El código del departamento destino no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //Y. Código Ciudad Destino:
        destinityCityCode = element[24] as string;
        if (destinityCityCode == null || destinityCityCode.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Y. El código de la ciudad destino no es válido.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }

        //Z. Estado Obra:
        if (element[25] as string != "A" && element[25] as string != "I" && element[25] as string != "S") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Z. El campo estado obra debe ser valores como: A / I / S.`;
          this.constructionSiteAlerts.push(alert);
          rowHasError = true;
        }
        if (element[25] as string === "A") {
          constructionSiteStateId = ConstructionSiteStateEnums.activa;
        } else if (element[25] as string === "I") {
          constructionSiteStateId = ConstructionSiteStateEnums.inactiva;
        } else {
          constructionSiteStateId = ConstructionSiteStateEnums.suspendida;
        }

        if (!rowHasError) {
          row = new ConstructionSiteImportModel(counter, branchCode, code, alterCode, name, enterpriseCode, conceptCode, swInvoiceMonthly,
            zoneCode, address, phone, alterPhone, email, clientDocument, clientDocument2, invoiceAddress, invoicePhone,
            invoiceAlterPhone, invoiceEmail, observation, swIcaRetainer, sellerDocument, originDepartmentCode, originCityCode, destinityDepartmentCode,
            destinityCityCode, constructionSiteStateId);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorConstructionSite = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        this.clearInputFile();
        return;
      }

      await this.processImportConstructionSites(rowsImports);
    });
  }


  async processImportConstructionSites(rowsImports: Array<ConstructionSiteImportModel>) {
    try {
      const response = await firstValueFrom(this.constructionSiteService.importConstructionSites(rowsImports));
      this.loadPreInvoicingModel = response;
      this.constructionSiteAlerts = response?.alerts ?? [];
      this.errorConstructionSite = response?.preInvoicingStateId;

      if (this.errorConstructionSite === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.constructionSiteAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.constructionSiteImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Obras.', error);
    }
  }
}
